document.addEventListener('click', (e) => {
  const target = e.target
  if(target.getAttribute('id') === 'StickyButtonAddToCart') {
    const mainAddButton = document.querySelector('button[type="submit"].content-form__button')
    if(mainAddButton) mainAddButton.click()
  } 
})

document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('.dtc-sticky-bar')
  const button = document.querySelector('button[type="submit"].content-form__button')

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const windowHeight = window.innerHeight;
      const scrollPosition = window.scrollY;
      if(entry.isIntersecting) { 
        // Hide sticky bar when it is intersecting with the viewport
        stickyBar.classList.add('not-visible') 
      } else if(window.innerWidth > 1024) {
        // Show sticky bar when it is not intersecting with the viewport
        if(scrollPosition > 530 && windowHeight < 799) {
          // Show sticky bar when the scroll position is greater than 530 and the window height is less than 799 (example devices: notebooks)
          stickyBar.classList.remove('not-visible')
        } else if(windowHeight > 800) {
          // Show sticky bar when the window height is greater than 800 (example devices: desktops)
          stickyBar.classList.remove('not-visible')
        }
      } else {
        stickyBar.classList.remove('not-visible')
      }
    })
  }, {
    root: null,
    threshold: 0.1
  })

  if (button) {
    observer.observe(button)
  }
})